import { render, staticRenderFns } from "./alipayAuthorize.vue?vue&type=template&id=321367b5"
import script from "./alipayAuthorize.vue?vue&type=script&lang=js"
export * from "./alipayAuthorize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports